<template>
	<div class="org-chart-glossary">
		<div
			v-for="(item) of items"
			class="org-chart-glossary-item"
		><span :style="{ backgroundColor: item.color }"></span>{{ item.label }}</div>
	</div>
</template>

<script>
export default {
	name: 'OrgChartGlossary',
	props: ['items'],
};
</script>

<style lang='scss' scoped>
.org-chart-glossary {
	padding: 10px;
	border: 1px solid #dddddd;
	border-radius: 5px;
	display: inline-block;
	.org-chart-glossary-item {
		color: var(--app-color-info);
		text-transform: uppercase;
		font-size: 12px;
		span {
			width: 10px;
			height: 10px;
			display: inline-block;
			margin-right: 5px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/organization-chart/OrgChartGlossary.vue